import 'bootstrap-daterangepicker/daterangepicker.css'
import { debounce } from 'lodash'
import moment from 'moment'
import { Alert, Spinner } from 'react-bootstrap'
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { FaHistory } from 'react-icons/fa'
import { FaCheck, FaEye } from 'react-icons/fa6'
import { IoIosRepeat, IoIosWarning, IoMdClose } from 'react-icons/io'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import ReactReadMoreReadLess from "react-read-more-read-less"
import { Link, useLocation } from 'react-router-dom'
import Select from '../../../components/textFields/AppSelect'
import { toast } from 'react-toastify'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { KTSVG } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp'
import DateComp from '../../../components/dateComponent/DateComp'
import DateRangeComp from '../../../components/dateComponent/DateRangeComp'
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent'
import NoRecordFound from '../../../components/noRecord/NoRecordFound'
import Pagination from '../../../components/pagination/Pagination'
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent'
import TableHeading from '../../../components/tableHeading/TableHeading'
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu'
import TextField from '../../../components/textFields/TextField'
import { constraintConfig } from '../../../constraintConfig'
import { selectAuth } from '../../../features/authSlice'
import { useAppSelector } from '../../../hooks'
import { useListingPageLayout } from '../../../hooks/useListingPageLayout'
import { useGetExpenseOfManagerTeamQuery, useGetExpensesOfDeletegateManagerTeamQuery, useGetExpensesOfProvidersQuery, useLazyGetExpenseItemByExpenseIdQuery } from '../../../services/ExpenseApi'
import { useGetAllExpenseTypeQuery, useGetDelegateManagersLookupQuery, useGetManagerTeamLookupQuery } from '../../../services/GeneralApi'
import { API_END_POINTS } from '../../../services/apiEndpoints'
import useColumnVisibility from '../../customHooks/useColumnVisibility'
import labelKey from "../../localization/label.json"
import tosterKey from "../../localization/toster.json"
import DownloadReport from '../reportAnalytics/DownloadReport'
import UpdateAprroverStatusModal from '../workFlow/UpdateAprroverStatusModal'
import CategoriesWithIcons from './CategoriesWithIcons'
import ExpenseDetailModal from './ExpenseDetailModal'
import ExpenseDetailModalForApproval from './ExpenseDetailModalForApproval'
import ExpenseDetailWithOcrModal from './ExpenseDetailWithOcrModal'
import ExpenseItemViolationModal from './ExpenseItemViolationModal'
import ExpenseLogModal from './ExpenseLogModal'
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent'
import SearchSelect from '../../../components/textFields/SearchSelect'
import { cacheClearHelper } from '../../../helpers/CacheClearHelper'

interface LightboxData {
    imageURL: string;
}

const TeamMemberExpenses = () => {
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'approvalQueue' });
    const location = useLocation();
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
    const { userAccountID, roleID, token, baseURL } = useAppSelector(selectAuth);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [searchStr, setSearchStr] = useState(' '); // debounce search
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("trackingId");
    const [sortOrder, setSortOrder] = useState("desc");
    // const [filterByDate, setFilterByDate] = useState("");
    const [filterByStatus, setFilterByStatus] = useState(1);
    const [sortedColumn, setSortedColumn] = useState("trackingId");
    const [checkedBoxes, setCheckedBoxes] = useState<string[]>([]);
    const [filterByStartDate, setFilterByStartDate] = useState("");
    const [filterByEndDate, setFilterByEndDate] = useState("");
    const [filterByManagerId, setFilterByManagerId] = useState(0);

    const [localFilterByStartDate, setLocalFilterByStartDate] = useState("");
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState("");
    const [localCheckedBoxes, setLocalCheckedBoxes] = useState<string[]>([]);
    const [filterByTrackingId, setFilterByTrackingId] = useState('');
    const [localFilterByTrackingId, setLocalFilterByTrackingId] = useState('');
    const [filterByTitle, setFilterByTitle] = useState('');
    const [localFilterByTitle, setLocalFilterByTitle] = useState('');
    const [filterByDescription, setFilterByDescription] = useState('');
    const [localFilterByDescription, setLocalFilterByDescription] = useState('');
    const [filterByAmount, setFilterByAmount] = useState('');
    const [localFilterByAmount, setLocalFilterByAmount] = useState('');
    const [filterByExpType, setFilterByExpType] = useState(0);
    const [localFilterByExpType, setLocalFilterByExpType] = useState(0);
    const [filterByClarification, setFilterByClarification] = useState('');
    const [localFilterByClarification, setLocalFilterByClarification] = useState('');


    const [isApplyingFilters, setIsApplyingFilters] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    const PAGE_INFO_SESSION_KEY = 'ss-approval-queue-info-dismissed'
    const [showPageInfo, setShowPageInfo] = useState(() => {
        try {
            return sessionStorage.getItem(PAGE_INFO_SESSION_KEY) !== '1'
        } catch {
            return true
        }
    })
    const dismissPageInfo = useCallback(() => {
        setShowPageInfo(false)
        try {
            sessionStorage.setItem(PAGE_INFO_SESSION_KEY, '1')
        } catch {
            /* ignore */
        }
    }, [])

    const [showInnerTable, setShowInnerTable] = useState(null);
    const [expenseItemData, setExpenseItemData] = useState<any>(null); // Initialize with null
    const [expenseItemDataIsLoading, setExpenseItemDataIsLoading] = useState(false);

    const [activeTab, setActiveTab] = useState(1);
    const [queueActiveTab, setQueueActiveTab] = useState(1);

    const { data: getManagerTeamLookup } = useGetManagerTeamLookupQuery({ managerId: userAccountID });
    const { data: getAllExpenseType } = useGetAllExpenseTypeQuery('')
    const [expenseItemByIdTrigger, { data: expenseItemsData, isFetching }] = useLazyGetExpenseItemByExpenseIdQuery({})

    const { data: allDelegateManagerLookup, refetch: delegateManagerLookupRefetch } = useGetDelegateManagersLookupQuery('')
    const userOptions = (getManagerTeamLookup?.result || []).map((user: any) => ({
        value: String(user.id),
        label: user.value,
    }))
    const selectedUserOptions = userOptions.filter((option: { value: string }) =>
        localCheckedBoxes.includes(option.value)
    )
    const queryHook = roleID === constraintConfig.roleID.roleExecutive ? useGetExpensesOfProvidersQuery :
        queueActiveTab === 2 ? useGetExpensesOfDeletegateManagerTeamQuery
            : useGetExpenseOfManagerTeamQuery;
    const { data, isFetching: isLoading, refetch, isSuccess } = queryHook({
        managerId: queueActiveTab === 2 ? filterByManagerId : userAccountID,
        pageNumber: page,
        pageSize: pageSize,
        sortBy: sortBy,
        sortOrder: sortOrder,
        searchStr: searchStr,
        startDate: filterByStartDate,
        endDate: filterByEndDate,
        filterByStatusId: filterByStatus,
        filterbyUser: checkedBoxes.length > 0 ? checkedBoxes : null,
        trackingId: filterByTrackingId,
        filterByTitleContains: filterByTitle,
        filterByDescription: filterByDescription,
        filterByAmount: filterByAmount,
        filterByExpType: filterByExpType,
        clarificationNote: filterByClarification,
    })

    const filteredQueueRows = useMemo(() => {
        const rows = data?.result?.data || []
        return rows.filter((row: any) => {
            if (filterByTitle && !(row.title || '').toLowerCase().includes(filterByTitle.toLowerCase())) {
                return false
            }
            if (filterByDescription && !(row.expenseDetail || '').toLowerCase().includes(filterByDescription.toLowerCase())) {
                return false
            }
            if (filterByAmount && !String(row.amount ?? '').includes(filterByAmount.trim())) {
                return false
            }
            if (filterByExpType && row.expenseType?.id !== filterByExpType) {
                return false
            }
            if (filterByClarification && !(row.clarificationNote || '').toLowerCase().includes(filterByClarification.toLowerCase())) {
                return false
            }
            return true
        })
    }, [data?.result?.data, filterByTitle, filterByDescription, filterByAmount, filterByExpType, filterByClarification])

    // Tab state and handler


    const handleTabChange = (status: number) => {
        setActiveTab(status);
        setFilterByStatus(status);
        setShowInnerTable(null);
        setPage(1)
        setPageSize(10)
    };
    const handleQueueTabChange = (status: number) => {
        setFilterByManagerId(0)
        setQueueActiveTab(status);
        setShowInnerTable(null);
        setPage(1);
        setPageSize(10);
    };

    // pagination
    const handlePageClick = (e: any) => {
        setPage(e.selected + 1);
    };
    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPage(1); // Reset page number to 1
    };
    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
        // Perform additional sorting logic...
    };

    //per page record
    const handlePageRecords = (e: any) => {
        setPage(1); // Reset the page to 1
    };
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state

        delayedSearch(value); // Update debounced search state
        setPage(1);
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );

    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);
    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate("");
        setFilterByEndDate("");
        setLocalFilterByStartDate("");
        setLocalFilterByEndDate("");
    };
    const handleFilterByUserTypeId = (selectedOption: any) => {
        setFilterByManagerId(selectedOption.value);
    };
    const handleTrackingIdSearchChange = (e: any) => {
        const { value } = e.target;
        setLocalFilterByTrackingId(value);
    };
    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setCheckedBoxes(localCheckedBoxes);
        setFilterByTrackingId(localFilterByTrackingId);
        setFilterByTitle(localFilterByTitle);
        setFilterByDescription(localFilterByDescription);
        setFilterByAmount(localFilterByAmount);
        setFilterByExpType(localFilterByExpType);
        setFilterByClarification(localFilterByClarification);
        setPage(1);
    };
    const resetFilters = () => {
        setFilterByStartDate('');
        setFilterByEndDate('');
        setCheckedBoxes([]);
        setLocalFilterByStartDate('');
        setLocalFilterByEndDate('');
        setLocalCheckedBoxes([]);
        setFilterByTrackingId('');
        setLocalFilterByTrackingId('');
        setFilterByTitle('');
        setLocalFilterByTitle('');
        setFilterByDescription('');
        setLocalFilterByDescription('');
        setFilterByAmount('');
        setLocalFilterByAmount('');
        setFilterByExpType(0);
        setLocalFilterByExpType(0);
        setFilterByClarification('');
        setLocalFilterByClarification('');
    }
    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
    }, [isApplyingFilters]);

    const fetchExpenseItemData = async (expenseId: any, token: any) => {
        const headers = {
            Authorization: `Bearer ${token}`, // Replace 'Bearer' with your token type if needed
            // Add any other headers you need here
        };
        const response = await fetch(`${baseURL}/api/Expense${API_END_POINTS.expenseItemById}?ExpenseId=${expenseId}`, {
            headers,
        });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return response.json();
    };


    const handleRowClick = async (rowId: any, expenseId: any) => {
        if (showInnerTable === rowId) {
            setShowInnerTable(null);
        } else {
            setShowInnerTable(rowId);
            if (expenseId) {
                setExpenseItemDataIsLoading(true);
                try {
                    const data = await fetchExpenseItemData(expenseId, token);
                    setExpenseItemData(data);

                } catch (error) {
                    setExpenseItemData(null);
                } finally {
                    setExpenseItemDataIsLoading(false); // Set loading state to false after fetching data
                }
            }
        }
    };
    const [showExpenseDetailModal, setShowExpenseDetailModal] = useState(false)
    const [expenseDetailData, setExpenseDetailData] = useState({});
    const expenseDetailHandler = () => {
        setShowExpenseDetailModal((prev) => !prev);
    };
    const [showExpenseDetailForApprovalModal, setShowExpenseDetailForApprovalModal] = useState(false)

    const expenseDetailForApprovalHandler = () => {
        setShowExpenseDetailForApprovalModal((prev) => !prev);
    };

    const [showExpenseDetailWithOcrModal, setShowExpenseDetailWithOcrModal] = useState(false)
    const expenseDetailWithOcrHandler = () => {
        setShowExpenseDetailWithOcrModal((prev) => !prev);
    };
    const [showExpenseItemViolationsModal, setShowExpenseItemViolationsModal] = useState(false)
    const [expenseItemId, setExpenseItemId] = useState();
    const expenseItemViolationsHandler = () => {
        setShowExpenseItemViolationsModal((prev) => !prev);
    };

    const [showUpdateApproverStatusModal, setShowUpdateApproverStatusModal] = useState(false)
    const [rejectExpense, setRejectExpense] = useState('')
    const [approvedExpense, setApprovedExpense] = useState('')
    const [editData, setEditData] = useState({});
    const editApproverStatusHandler = () => {
        setShowUpdateApproverStatusModal((prev) => !prev);
    };

    const [showExpenseLogModal, setShowExpenseLogModal] = useState(false)
    const [expenseLogData, setExpenseLogData] = useState({});
    const expenseLogHandler = () => {
        setShowExpenseLogModal((prev) => !prev);
    };



    const handleRefresh = () => {
        setShowInnerTable(null)
        refetch()
            .then(() => {
                if (isSuccess) {
                    toast.success(tosterKey.dataRefreshedSuccesfully);
                }
            });
    };
    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "asc" ||
            sortBy === "") {
            refetch();
        }
    }, [sortOrder, sortBy, searchStr]);

    const isPdfFile = (filePath: string | undefined) => {
        if (!filePath) return false;
        const fileExtension = filePath.toLowerCase().split('.').pop();
        return fileExtension === 'pdf';
    };
    const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
        if (attachmentFile) {
            if (isPdfFile(attachmentFile)) {
                // For PDF files, open in the browser
                window.open(attachmentFile, '_blank');
            } else {
                // For image files, open in the Lightbox
                setLightboxData({ imageURL: attachmentFile });
                setLightboxOpen(true);
            }
        }
    };
    useEffect(() => {
        // Check the current route and set the selected value accordingly
        if (location.pathname === '/approval-queue/all') {
            setFilterByStatus(0);
            setActiveTab(0);
        }
    }, [location.pathname]);

    // Define the styles for react-select with proper typing - using any to bypass the type issue
    const selectStyles: any = {
        control: (base: any) => ({
            ...base,
            minHeight: 34,
            height: 34,
            overflow: 'hidden',
        }),
        valueContainer: (base: any) => ({
            ...base,
            flexWrap: 'nowrap',
            overflow: 'hidden',
            padding: '0 8px',
        }),
        indicatorsContainer: (base: any) => ({
            ...base,
            height: 34,
        }),
        multiValue: (base: any) => ({
            ...base,
            maxWidth: '72%',
        }),
        menu: (base: any) => ({
            ...base,
            marginTop: 4,
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 10060,
        }),
    };

    return (
        <>
            <UpdateAprroverStatusModal
                show={showUpdateApproverStatusModal}
                handleClose={() => setShowUpdateApproverStatusModal(false)}
                data={editData}
                approvedExpense={approvedExpense}
                rejectExpense={rejectExpense}
                refetch={refetch}
                setShowInnerTable={setShowInnerTable} />
            <ExpenseDetailModal show={showExpenseDetailModal} handleClose={() => setShowExpenseDetailModal(false)} data={expenseDetailData} expenseItems={expenseItemsData?.result} itsApprover={true} />
            <ExpenseDetailModalForApproval show={showExpenseDetailForApprovalModal} handleClose={() => setShowExpenseDetailForApprovalModal(false)} data={expenseDetailData} expenseItems={expenseItemsData?.result} refetch={refetch} itsApprover={true} isFetching={isFetching} expenseItemByIdTrigger={expenseItemByIdTrigger} />

            <ExpenseLogModal show={showExpenseLogModal} handleClose={() => setShowExpenseLogModal(false)} data={expenseLogData} />
            <ExpenseDetailWithOcrModal show={showExpenseDetailWithOcrModal} handleClose={() => setShowExpenseDetailWithOcrModal(false)} data={expenseDetailData} refetch={refetch} />
            <ExpenseItemViolationModal show={showExpenseItemViolationsModal} handleClose={() => setShowExpenseItemViolationsModal(false)} data={expenseDetailData} expenseItemId={expenseItemId} refetch={refetch} setShowInnerTable={setShowInnerTable} />


            <PageTitle breadcrumbs={[]}>{labelKey.approvalQueue}</PageTitle>
            <div className={`card ss-approval-queue-card${showFilters ? ' ss-aq-filters-open' : ''}`}>
                <div className='card-header border-0 pt-5 ss-aq-card-header'>
                    {showPageInfo && (
                        <Alert variant="primary" className='ss-page-info-alert ss-page-info-alert--full w-100 mt-0 mb-0 py-2'>
                            <div className='ss-page-info-alert__body'>
                                <p className='mb-0'>
                                    Review expense reports in your approval queue. Expand a row to see line items, use Filters to narrow by date, report, user, title, or amount, and approve or reject from the sticky Actions column.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="btn btn-sm btn-icon btn-active-color-primary ss-page-info-alert__close"
                                aria-label="Close"
                                title="Close"
                                onClick={dismissPageInfo}
                            >
                                <i className="fas fa-times" />
                            </button>
                        </Alert>
                    )}
                    <div className='ss-aq-main-tabs d-flex align-items-center flex-wrap gap-2 w-100'>
                        {roleID !== constraintConfig.roleID.roleExecutive && (
                            <div className='btn-group'>
                                <button
                                    type='button'
                                    className={`btn btn-sm ${queueActiveTab === 1 ? 'btn-primary' : 'btn-light-primary'}`}
                                    onClick={() => {
                                        handleQueueTabChange(1);
                                    }}
                                >
                                    {labelKey.myApprovalQueue}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-sm ${queueActiveTab === 2 ? 'btn-primary' : 'btn-light-primary'}`}
                                    onClick={() => {
                                        handleQueueTabChange(2);
                                        setFilterByManagerId(filterByManagerId);
                                        cacheClearHelper()
                                        delegateManagerLookupRefetch();
                                    }}
                                >
                                    {labelKey.delegateApprovalQueue}
                                </button>
                            </div>
                        )}
                        {queueActiveTab === 2 && (
                            <div className='ss-aq-delegate-select' style={{ minWidth: 220 }}>
                                <SearchSelect
                                    options={[
                                        ...(Array.isArray(allDelegateManagerLookup?.result) ? allDelegateManagerLookup.result.map((option: any) => ({
                                            value: option.id,
                                            label: option?.value,
                                        })) : [])
                                    ]}
                                    placeholder='Select Delegate Manager'
                                    value={filterByManagerId && filterByManagerId !== 0
                                        ? {
                                            value: filterByManagerId,
                                            label: allDelegateManagerLookup?.result.find((option: any) => option.id === filterByManagerId)?.value
                                        }
                                        : null
                                    }
                                    onChange={handleFilterByUserTypeId}
                                />
                            </div>
                        )}
                        <Tooltip id="refreshData" place="top" />
                        <Tooltip
                            id="expense-report-expand"
                            place="right"
                            positionStrategy="fixed"
                        />
                        <RefreshComponent onClick={handleRefresh} />
                    </div>
                    <div className='ss-aq-status-row d-flex align-items-center flex-wrap gap-2 w-100'>
                        <div className='btn-group'>
                            <button
                                type='button'
                                className={`btn btn-sm ${activeTab === 1 ? 'btn-primary' : 'btn-light-primary'}`}
                                onClick={() => handleTabChange(1)}
                            >
                                {labelKey.pending}
                            </button>
                            <button
                                type='button'
                                className={`btn btn-sm ${activeTab === 2 ? 'btn-primary' : 'btn-light-primary'}`}
                                onClick={() => handleTabChange(2)}
                            >
                                {labelKey.approved}
                            </button>
                            <button
                                type='button'
                                className={`btn btn-sm ${activeTab === 4 ? 'btn-primary' : 'btn-light-primary'}`}
                                onClick={() => handleTabChange(4)}
                            >
                                {labelKey.rejected}
                            </button>
                            <button
                                type='button'
                                className={`btn btn-sm ${activeTab === 0 ? 'btn-primary' : 'btn-light-primary'}`}
                                onClick={() => handleTabChange(0)}
                            >
                                {labelKey.all}
                            </button>
                        </div>
                        <div className='d-flex align-items-center flex-wrap gap-2 ms-lg-auto'>
                            <SearchBarComponent
                                placeholder='Expense'
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                                className='ss-user-toolbar-search-input'
                                mainClassName='ss-table-search--sm my-0'
                            />
                            {!showFilters ? (
                                <button
                                    type="button"
                                    className="btn btn-sm ss-pill-btn ss-pill-btn-filter-active"
                                    onClick={() => setShowFilters(true)}
                                >
                                    <i className="fa fa-filter me-1 text-white" />
                                    Show Filters
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-sm ss-pill-btn ss-pill-btn-filter-active"
                                    onClick={() => setShowFilters(false)}
                                >
                                    <i className="fa fa-eye-slash me-1 text-white" />
                                    Hide Filters
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <div className='card-body py-4'>
                    {showFilters && (
                        <div className='ss-approval-queue-filters mb-3'>
                            <div className='ss-approval-queue-filters__field'>
                                <DateRangeComp
                                    label="Date Range"
                                    startDate={localFilterByStartDate || moment()}
                                    endDate={localFilterByEndDate || moment()}
                                    onApply={handleDateRangeChange}
                                    onCancel={handleCancelDateSelection}
                                    value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "MM/DD/YYYY"}
                                    className="mb-0"
                                />
                            </div>
                            <div className='ss-approval-queue-filters__field'>
                                <TextField
                                    label={`${labelKey.reportId}:`}
                                    placeholder='Search Tracking ID...'
                                    value={localFilterByTrackingId}
                                    onChange={handleTrackingIdSearchChange}
                                />
                            </div>
                            <div className='ss-approval-queue-filters__field'>
                                <TextField
                                    label={`${labelKey.title}:`}
                                    placeholder='Search Title...'
                                    value={localFilterByTitle}
                                    onChange={(e) => setLocalFilterByTitle(e.target.value)}
                                />
                            </div>
                            <div className='ss-approval-queue-filters__field'>
                                <TextField
                                    label={`${labelKey.description}:`}
                                    placeholder='Search Description...'
                                    value={localFilterByDescription}
                                    onChange={(e) => setLocalFilterByDescription(e.target.value)}
                                />
                            </div>
                            <div className='ss-approval-queue-filters__field'>
                                <TextField
                                    label={`${labelKey.amount}:`}
                                    placeholder='Search Amount...'
                                    value={localFilterByAmount}
                                    onChange={(e) => setLocalFilterByAmount(e.target.value)}
                                />
                            </div>
                            <div className='ss-approval-queue-filters__field'>
                                <TextField
                                    label={`${labelKey.clarificationNote}:`}
                                    placeholder='Search Note...'
                                    value={localFilterByClarification}
                                    onChange={(e) => setLocalFilterByClarification(e.target.value)}
                                />
                            </div>
                            {(roleID === constraintConfig.roleID.role4 || roleID === constraintConfig.roleID.roleExecutive) && (
                                <div className='ss-approval-queue-filters__field ss-aq-users-filter'>
                                    <label className='form-label fs-6 fw-bold'>{labelKey.users}:</label>
                                    <Select
                                        isMulti
                                        isSearchable
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        blurInputOnSelect={false}
                                        className='w-100'
                                        classNamePrefix="react-select"
                                        placeholder="Search User..."
                                        options={userOptions}
                                        value={selectedUserOptions}
                                        menuPlacement="bottom"
                                        maxMenuHeight={220}
                                        noOptionsMessage={() => 'No users found'}
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                        menuPosition="fixed"
                                        styles={selectStyles}
                                        formatOptionLabel={(option: any, meta: { context: string }) =>
                                            meta.context === 'menu' ? (
                                                <div className='d-flex align-items-center gap-2'>
                                                    <input
                                                        type='checkbox'
                                                        readOnly
                                                        className='form-check-input mt-0'
                                                        checked={selectedUserOptions.some((selected: any) => selected.value === option.value)}
                                                    />
                                                    <span>{option.label}</span>
                                                </div>
                                            ) : option.label
                                        }
                                        onChange={(selected) => {
                                            const next = Array.isArray(selected)
                                                ? selected.map((option: any) => String(option.value))
                                                : []
                                            setLocalCheckedBoxes(next)
                                        }}
                                    />
                                </div>
                            )}
                            <div className='ss-approval-queue-filters__actions'>
                                <button type='button' className='btn btn-sm btn-danger text-nowrap' onClick={resetFilters}>
                                    Reset Filters
                                </button>
                                <button type='button' className='btn btn-sm btn-primary text-nowrap' onClick={applyFilters}>
                                    {isApplyingFilters ? (
                                        <>
                                            <span>loading...</span>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        </>
                                    ) : (
                                        'Apply Filters'
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                    <Tooltip id="expense-violation" place="left" positionStrategy="fixed" />
                    <Tooltip id="approve-status" place="left" positionStrategy="fixed" />
                    <Tooltip id="expense-log" place="left" positionStrategy="fixed" />
                    <Tooltip id="expense-detail" place="left" positionStrategy="fixed" />

                    <div className='table-responsive table-height'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bold text-muted'>
                                    {hiddenColumns.includes('trackingId') && (
                                        <TableHeading
                                            label={labelKey.reportId}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='trackingId'
                                            className="ps-4"
                                        />
                                    )}
                                    {hiddenColumns.includes('userAccount') && (
                                        <TableHeading
                                            label={labelKey.reportees}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='userAccount'
                                        />
                                    )}
                                    {hiddenColumns.includes('expenseType') && (
                                        <TableHeading
                                            label={labelKey.type}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='expenseType'
                                        />
                                    )}
                                    {hiddenColumns.includes('title') && (
                                        <TableHeading
                                            label={labelKey.title}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='title'
                                            className="w-200px"
                                        />
                                    )}
                                    {hiddenColumns.includes('expenseDetail') && (
                                        <TableHeading
                                            label={labelKey.description}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='expenseDetail'
                                            className="w-200px"
                                        />
                                    )}
                                    {hiddenColumns.includes('amount') && (
                                        <TableHeading
                                            label={labelKey.totalAmount}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='amount'
                                            className="text-end mw-100px"
                                        />
                                    )}
                                    {hiddenColumns.includes('reportDate') && (
                                        <TableHeading
                                            label={labelKey.date}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='reportDate'
                                        />
                                    )}
                                    {hiddenColumns.includes('expenseStatus') && (
                                        <TableHeading
                                            label={labelKey.status}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='expenseStatus'
                                        />
                                    )}
                                    {hiddenColumns.includes('clarificationNote') && (
                                        <TableHeading
                                            label={labelKey.clarificationNote}
                                            columnId='clarificationNote'
                                            className='w-300px'
                                        />
                                    )}
                                    <th className='text-end rounded-end pe-2 border-0 sticky-table-actions'>
                                        {labelKey.actions}
                                        <TableSettingMenu
                                            tooltipId="approval-queue-columns-menu"
                                            tooltipContent="Approval Queue Columns Menu"
                                            menuTitle="Approval Queue Display Menu"
                                        >
                                            <TextField
                                                rightLabel={labelKey.reportId}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("trackingId")}
                                                checked={hiddenColumns.includes('trackingId')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.reportees}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("userAccount")}
                                                checked={hiddenColumns.includes('userAccount')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.title}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("title")}
                                                checked={hiddenColumns.includes('title')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.description}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("expenseDetail")}
                                                checked={hiddenColumns.includes('expenseDetail')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.totalAmount}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("amount")}
                                                checked={hiddenColumns.includes('amount')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.date}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("reportDate")}
                                                checked={hiddenColumns.includes('reportDate')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.status}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("expenseStatus")}
                                                checked={hiddenColumns.includes('expenseStatus')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.clarificationNote}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("clarificationNote")}
                                                checked={hiddenColumns.includes('clarificationNote')}
                                                fieldClass='mb-4'
                                            />
                                        </TableSettingMenu>
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading &&
                                    <>
                                        {filteredQueueRows.length > 0 ? (
                                            <>
                                                {filteredQueueRows.map((data: any, index: any) => (
                                                    <Fragment key={index}>
                                                        <tr
                                                            data-tooltip-id="expense-report-expand"
                                                            data-tooltip-content={labelKey.clickHereToExpand}
                                                            className={`cursor-pointer ${showInnerTable === index ? 'highlighted-row' : ''}`}
                                                            onClick={() => {
                                                                handleRowClick(index, data?.expenseId);
                                                            }}>
                                                            {hiddenColumns.includes('trackingId') && (
                                                                <td className='ps-5'>{data?.trackingId}</td>
                                                            )}
                                                            {hiddenColumns.includes('userAccount') && (
                                                                <td>
                                                                    <Link to={`/user-profile/expense-items/${data.userAccount?.orgUserID}`}>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='symbol symbol-50px me-5'>
                                                                                {/* {data?.userAccount?.imageUrl ? <img src={data?.userAccount?.imageUrl} alt="" /> : */}
                                                                                <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">{data?.userAccount?.firstName?.charAt(0)}</div>
                                                                                {/* } */}
                                                                            </div>
                                                                            <div className='d-flex justify-content-start flex-column'>
                                                                                <span className='text-capitalize mb-0'>
                                                                                    {data?.userAccount?.firstName}  {data?.userAccount?.middleName} {data?.userAccount?.lastName}
                                                                                </span>
                                                                                <span className='text-muted fw-semibold text-muted d-block fs-7 text-lowercase'>
                                                                                    {data?.userAccount?.email}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('expenseType') && (
                                                                <td>{data?.expenseType?.title}</td>
                                                            )}
                                                            {hiddenColumns.includes('title') && (
                                                                <td>{data?.title}</td>
                                                            )}
                                                            {hiddenColumns.includes('expenseDetail') && (
                                                                <td className='w-300px text-wrap'>
                                                                    {data && data.expenseDetail && <ReactReadMoreReadLess
                                                                        charLimit={30}
                                                                        readMoreText={"Read more"}
                                                                        readLessText={"Read less"}
                                                                        readMoreClassName="readMore"
                                                                        readLessClassName="readLess"
                                                                    >
                                                                        {data.expenseDetail}
                                                                    </ReactReadMoreReadLess>}
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('amount') && (
                                                                <td className='text-end'>
                                                                    <CurrencyComp amount={data?.amount} />
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('reportDate') && (
                                                                <td><DateComp formattedDate={data?.reportDate} /></td>
                                                            )}
                                                            {hiddenColumns.includes('expenseStatus') && (
                                                                <td>
                                                                    {data?.approverStatus?.id === constraintConfig.approverStatus.pending ?
                                                                        <span className="badge badge-light-primary fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                                                                        data?.approverStatus?.id === constraintConfig.approverStatus.approved ?
                                                                            <span className="badge badge-light-success fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                                                                            data?.approverStatus?.id === constraintConfig.approverStatus.rejected ?
                                                                                <span className="badge badge-light-danger fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                                                                                // data?.approverStatus?.id === "Clarification" ?
                                                                                //     <span className="badge badge-light-warning fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                                                                                data?.approverStatus?.id === constraintConfig.approverStatus.accountsPayable ?
                                                                                    <span className="badge badge-light-success fs-7 fw-semibold">{data?.approverStatus?.title}</span> :
                                                                                    <span className="badge badge-light-primary fs-7 fw-semibold">{data?.approverStatus?.title}</span>
                                                                    }
                                                                </td>
                                                            )}
                                                            {hiddenColumns.includes('clarificationNote') && (
                                                                <td className='text-wrap w-300px'>
                                                                    {data && data.clarificationNote && <ReactReadMoreReadLess
                                                                        charLimit={30}
                                                                        readMoreText={"Read more"}
                                                                        readLessText={"Read less"}
                                                                        readMoreClassName="readMore"
                                                                        readLessClassName="readLess"
                                                                    >
                                                                        {data.clarificationNote}
                                                                    </ReactReadMoreReadLess>}
                                                                </td>
                                                            )}
                                                            <td className='text-end sticky-table-actions' onClick={(event) => event.stopPropagation()}>
                                                                    <div className='d-flex align-items-center justify-content-end gap-2' >
                                                                        {data?.isMgrViolation === true ?
                                                                            <div
                                                                                data-tooltip-id="expense-violation"
                                                                                data-tooltip-content='Expense violation'
                                                                                data-tooltip-place="left"
                                                                                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                                                onClick={() => {
                                                                                    setExpenseDetailData(data);
                                                                                    expenseDetailWithOcrHandler();
                                                                                }}
                                                                            >
                                                                                <IoIosWarning className='text-danger h-15px w-15px' />
                                                                            </div>
                                                                            : data?.isMgrViolation === false ?
                                                                                <div
                                                                                    data-tooltip-id="expense-violation"
                                                                                    data-tooltip-content='Expense violation'
                                                                                    data-tooltip-place="left"
                                                                                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                                                    onClick={() => {
                                                                                        setExpenseDetailData(data);
                                                                                        expenseDetailWithOcrHandler();
                                                                                    }}
                                                                                >
                                                                                    <IoIosWarning className='text-success h-15px w-15px' />
                                                                                </div> : null
                                                                        }
                                                                        {data?.approverStatus?.id === 1 && (
                                                                            <div
                                                                                data-tooltip-id="approve-status"
                                                                                data-tooltip-content='Approve & Reject Report with items'
                                                                                data-tooltip-place="left"
                                                                                className='btn btn-bg-light btn-active-color-primary btn-sm'
                                                                                onClick={() => {
                                                                                    expenseItemByIdTrigger({ ExpenseId: data?.expenseId });
                                                                                    setExpenseDetailData(data);
                                                                                    expenseDetailForApprovalHandler();
                                                                                }}
                                                                            >
                                                                                <FaCheck className='h-14px w-14px' /> & <IoMdClose className='h-15px w-15px' />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            data-tooltip-id="expense-log"
                                                                            data-tooltip-content='Expense Log'
                                                                            data-tooltip-place="left"
                                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                                            onClick={() => {
                                                                                setExpenseLogData(data);
                                                                                expenseLogHandler();
                                                                            }}
                                                                        >
                                                                            <FaHistory className='text-dark text-hover-primary' />
                                                                        </div>
                                                                        <div
                                                                            data-tooltip-id="expense-detail"
                                                                            data-tooltip-content='Expense Detail'
                                                                            data-tooltip-place="left"
                                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                                            onClick={() => {
                                                                                expenseItemByIdTrigger({ ExpenseId: data?.expenseId });
                                                                                setExpenseDetailData(data);
                                                                                expenseDetailHandler();
                                                                            }}
                                                                        >
                                                                            <KTSVG
                                                                                path='/media/icons/duotune/arrows/arr064.svg'
                                                                                className='svg-icon-3'
                                                                            />
                                                                        </div>
                                                                        <DownloadReport data={data} />
                                                                    </div>
                                                                </td>
                                                        </tr>
                                                        {showInnerTable === index && (
                                                            <tr
                                                                className={`inner-row ${showInnerTable === index ? 'highlighted-row' : ''}`}>
                                                                <td className='pt-0 ps-3 pe-0' colSpan={10}>
                                                                    <div className="ss-expense-nested-line-items">
                                                                        <table className="table align-middle gs-0 gy-4">
                                                                            <thead>
                                                                                <tr className='fw-bold text-muted bg-light'>
                                                                                    <th className='ps-4 w-50px'>{labelKey.sr}</th>
                                                                                    <th className='ps-4'>{labelKey.itemDate}</th>
                                                                                    <th>{labelKey.expenseType}</th>
                                                                                    <th>{labelKey.category}</th>
                                                                                    {/* <th>{labelKey.currency}</th> */}
                                                                                    <th className='w-100px text-end pe-15'>{labelKey.amount}</th>
                                                                                    <th className='w-150px text-end pe-15'>{labelKey.reimbursableDistance}</th>
                                                                                    <th>{labelKey.vendor}</th>
                                                                                    <th>{labelKey.paymentMethod}</th>
                                                                                    {/* <th>{labelKey.receipt}</th> */}
                                                                                    <th>{labelKey.attachment}</th>
                                                                                    <th>{labelKey.description}</th>
                                                                                    <th>{labelKey.source}</th>
                                                                                    <th className='text-end pe-3 sticky-table-actions'>{labelKey.action}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {!expenseItemDataIsLoading && <>
                                                                                    {expenseItemData?.result?.map((itemData: any, index: any) => (
                                                                                        <tr key={index}>
                                                                                            <td className=' ps-5'>
                                                                                                {index + 1}
                                                                                            </td>
                                                                                            <td className='ps-4'><DateComp formattedDate={itemData.itemDate} /></td>
                                                                                            <td>{itemData?.expenseType?.title}</td>
                                                                                            <td className='ps-5'><CategoriesWithIcons itemData={itemData} /></td>
                                                                                            {/* <td>{itemData?.currency?.title}</td> */}
                                                                                            <td className='text-end pe-15'>
                                                                                                <CurrencyComp amount={itemData?.amount} />
                                                                                            </td>
                                                                                            <td className='text-end pe-15'>
                                                                                                {itemData?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                                                                                    <>
                                                                                                        {itemData?.reimbursableDistance}
                                                                                                    </>
                                                                                                    : null
                                                                                                }
                                                                                            </td>
                                                                                            <td>{itemData?.vendor?.name !== " " ? itemData?.vendor?.name : "N/A"}</td>
                                                                                            <td>{itemData?.paymentMethod?.title}</td>
                                                                                            {/* <td>
                                                                                                {itemData?.ocrPassed === true ?
                                                                                                    <span className="badge badge-light-success fs-7 fw-semibold">Passed</span> :
                                                                                                    <span className="badge badge-light-danger fs-7 fw-semibold">Failed</span>
                                                                                                }
                                                                                            </td> */}

                                                                                            <td>
                                                                                                {itemData?.attachmentFile === null ||
                                                                                                    itemData?.attachmentFile === 'null' ||
                                                                                                    itemData?.attachmentFile === "undefined" ||
                                                                                                    itemData?.attachmentFile === "" ||
                                                                                                    itemData?.attachmentFile === "Receipt is not available" ?
                                                                                                    <span className='ps-9'>N/A</span> :
                                                                                                    <FaEye className='ms-10' onClick={() => openPdfInBrowserOrLightbox(itemData?.attachmentFile)} />
                                                                                                }
                                                                                                {lightboxOpen && (
                                                                                                    <Lightbox
                                                                                                        mainSrc={lightboxData.imageURL}
                                                                                                        onCloseRequest={() => setLightboxOpen(false)}
                                                                                                        imageCaption="Attachment"
                                                                                                        enableZoom={true}
                                                                                                        imagePadding={50}
                                                                                                    />
                                                                                                )}
                                                                                            </td>
                                                                                            <td>{itemData?.itemDetail?.length > 60 ? `${itemData?.itemDetail.substring(0, 40)}...` : itemData?.itemDetail}</td>
                                                                                            <td>
                                                                                                {itemData?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                                                                                    <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4'
                                                                                                        svgClassName='w-20px h-20px'
                                                                                                        data-tooltip-id="web-source" data-tooltip-content='Website' />
                                                                                                    :
                                                                                                    itemData?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                                                                                        <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4'
                                                                                                            data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                                                                                        itemData?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                                                                                            <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4'
                                                                                                                data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                                                                                            : itemData?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                                                                                                <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                                                                                                    data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                                                                                            </td>
                                                                                            <td className='text-end sticky-table-actions'>
                                                                                                <div className='d-flex justify-content-end'>
                                                                                                    {itemData?.isMgrViolation === true ?
                                                                                                        <div
                                                                                                            data-tooltip-id="expense-violation" data-tooltip-content='Expense violation'
                                                                                                            data-tooltip-place="left"
                                                                                                            className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                                                                            onClick={() => {
                                                                                                                setExpenseDetailData(data);
                                                                                                                setExpenseItemId(itemData?.expenseItemId)
                                                                                                                expenseItemViolationsHandler();
                                                                                                            }}
                                                                                                        >
                                                                                                            <IoIosWarning className='text-danger h-15px w-15px' />
                                                                                                        </div>
                                                                                                        : data?.isMgrViolation === false ?
                                                                                                            <div
                                                                                                                data-tooltip-id="expense-violation" data-tooltip-content='Expense violation'
                                                                                                                data-tooltip-place="left"
                                                                                                                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                                                                                onClick={() => {
                                                                                                                    setExpenseDetailData(data);
                                                                                                                    setExpenseItemId(itemData?.expenseItemId)
                                                                                                                    expenseItemViolationsHandler();
                                                                                                                }}
                                                                                                            >
                                                                                                                <IoIosWarning className='text-success h-15px w-15px' />
                                                                                                            </div>
                                                                                                            : null
                                                                                                    }
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </>}
                                                                                {expenseItemDataIsLoading && (
                                                                                    <tr>
                                                                                        <td colSpan={11} className="text-center">
                                                                                            <LoadingComponent />
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Fragment>
                                                ))}
                                            </>
                                        ) :
                                            (
                                                <tr>
                                                    <td colSpan={11}>
                                                        {queueActiveTab === 2 ?
                                                            <h4 className="mb-0 text-gray-600 text-center py-5"> {labelKey.selectDelegateManager}</h4> :
                                                            <NoRecordFound />
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </>
                                }
                                {isLoading && (
                                    <tr>
                                        <td colSpan={10} className="text-center">
                                            <LoadingComponent />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table >
                    </div >
                    <Pagination
                        totalResult={data?.result?.totalRecords === 0 ? 0 : ((data?.result?.pageNumber - 1) * data?.result?.pageSize) + 1}
                        toResult={data?.result?.totalRecords === 0 ? 0 : Math.min(data?.result?.pageNumber * data?.result?.pageSize, data?.result?.totalRecords)}
                        ofResult={data?.result?.totalRecords}
                        onChange={handlePageSizeChange}
                        pageSize={pageSize}
                        onPageChange={handlePageClick}
                        pageCount={data?.result?.totalPages || 0}
                        currentPage={page}
                    />
                    {/* end::Table container */}
                </div >


                {/* begin::Body */}
            </div >
        </>
    )
}

export default TeamMemberExpenses